import React from "react";
import LegalLayout, { Section } from "@/components/LegalLayout";

export default function Refund() {
  return (
    <LegalLayout title="Refund & Cancellation Policy">
      <Section title="1. Try Setubuild.OS Free — No Card, No Risk">
        <p>Every account starts with a <strong>14-day free trial</strong>. No credit card required at signup. Use every feature, invite your team, generate real reports — all free. This is the best way to know whether Setubuild.OS fits your workflow before paying.</p>
      </Section>

      <Section title="2. 7-Day Money-Back Guarantee (Monthly Plans)">
        <p>If you subscribed to a monthly plan and are not satisfied, request a refund within <strong>7 days of your first paid subscription</strong>. We will refund 100% of the amount to your original payment method automatically via Razorpay within 5–7 business days.</p>
      </Section>

      <Section title="3. Prorated Refund (Yearly Plans)">
        <p>Yearly plans may be refunded within <strong>30 days of first payment</strong>, prorated for the unused months. Example: on a ₹24,990/year plan cancelled after 45 days, we refund approximately <span className="mono">₹24,990 × 10.5 / 12 ≈ ₹21,866</span>.</p>
      </Section>

      <Section title="4. Eligibility Conditions">
        <ul className="list-disc pl-6 space-y-1">
          <li>Refunds apply only to your <strong>first paid subscription</strong> (not to renewals).</li>
          <li>Your AI usage in the paid period must be under <strong>20% of the plan quota</strong> (e.g. under 100 of 500 AI scans on Pro).</li>
          <li>WhatsApp messages already delivered are non-refundable (paid to Twilio on your behalf).</li>
          <li>Add-on packs already consumed are non-refundable.</li>
          <li>Custom onboarding or setup services already delivered are non-refundable.</li>
        </ul>
      </Section>

      <Section title="5. Cancellation Anytime — No Questions Asked">
        <p>You can cancel your subscription from <strong>Settings → Subscription</strong>. Cancellation stops the next renewal. You retain access to your paid plan until the end of the current billing period.</p>
      </Section>

      <Section title="6. How to Request a Refund">
        <ol className="list-decimal pl-6 space-y-1">
          <li>Email <span className="mono">setubuildtechnologies@gmail.com</span> from your registered account email. Include your Razorpay Order ID (visible in Settings → Subscription).</li>
          <li>We acknowledge within 24 business hours.</li>
          <li>If eligible, the refund is triggered via Razorpay within 3 business days.</li>
          <li>Razorpay / your bank posts the amount within an additional 3–5 business days depending on card / UPI / netbanking.</li>
        </ol>
      </Section>

      <Section title="7. Chargebacks & Disputes">
        <p>Please reach out to us <em>before</em> initiating a chargeback with your bank. Direct chargebacks harm our merchant standing and rarely deliver a faster refund than our automated flow. Unresolved disputes may be escalated to the National Consumer Helpline at <a className="text-primary underline" href="https://consumerhelpline.gov.in" target="_blank" rel="noreferrer">consumerhelpline.gov.in</a>.</p>
      </Section>

      <Section title="8. Fair Use Reservation">
        <p>Setubuild.OS reserves the right, at its sole discretion, to decline refunds for accounts showing patterns of abuse (repeated trials via disposable emails, refund-and-resubscribe cycles, or violation of the Terms of Service). Genuine cases will always be considered fairly.</p>
      </Section>

      <Section title="9. Contact">
        <p>SetuBuild Technologies · Bharat</p>
        <p>Billing — <span className="mono">setubuildtechnologies@gmail.com</span> · Phone: +91 97667 44746</p>
        <p>Business Hours: Mon–Sat, 10 am – 7 pm IST · Full details on our <a href="/contact" className="text-primary underline">Contact page</a>.</p>
      </Section>
    </LegalLayout>
  );
}
